module.exports = __webpack_public_path__ + "static/media/black-smooth-textured-paper.0cc102d4.jpg";